import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { refreshOnlinePresence } from '../../services/api';
import { RootState } from '../../store';

const PRESENCE_REFRESH_INTERVAL_MS = 30_000;

export function useOnlinePresence() {
	const isLogged = useSelector((state: RootState) => state.auth.isLogged);

	useEffect(() => {
		if (!isLogged) return;

		const refresh = () => {
			refreshOnlinePresence().catch(() => {
				// Presence is best-effort and will be retried on the next interval.
			});
		};

		refresh();
		const interval = setInterval(refresh, PRESENCE_REFRESH_INTERVAL_MS);

		return () => clearInterval(interval);
	}, [isLogged]);
}
